import { motion, AnimatePresence } from "framer-motion";
import { ShoppingCart } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useStore } from "../context/StoreContext";

export const FloatingCart = () => {
  const { L, count, cartOpen, setCartOpen } = useStore();
  const { pathname } = useLocation();
  const hidden = cartOpen || pathname.startsWith("/admin") || pathname.startsWith("/payment");

  return (
    <motion.div
      className="fixed bottom-5 right-5 z-[70]"
      initial={false}
      animate={{ opacity: hidden ? 0 : 1, scale: hidden ? 0.6 : 1 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      style={{ pointerEvents: hidden ? "none" : "auto" }}
      aria-hidden={hidden}
    >
      <motion.button
        data-testid="floating-cart-button"
        onClick={() => setCartOpen(true)}
        whileHover={{ scale: 1.07 }}
        whileTap={{ scale: 0.92 }}
        aria-label={L.cart.floating}
        title={L.cart.floating}
        className="relative w-14 h-14 rounded-full bg-onyx/90 backdrop-blur-md border border-gold/40 hover:border-gold shadow-[0_10px_35px_rgba(0,0,0,0.55)] flex items-center justify-center transition-colors"
      >
        <ShoppingCart className="w-5 h-5 text-gold" strokeWidth={1.5} />
        <AnimatePresence mode="popLayout">
          {count > 0 && (
            <motion.span
              key={count}
              data-testid="floating-cart-badge"
              initial={{ scale: 0.3, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.3, opacity: 0 }}
              transition={{ type: "spring", stiffness: 500, damping: 22 }}
              className="absolute -top-1 -right-1 min-w-[1.3rem] h-5 px-1 rounded-full bg-gold text-obsidian text-[0.65rem] font-bold flex items-center justify-center"
            >
              {count}
            </motion.span>
          )}
        </AnimatePresence>
      </motion.button>
    </motion.div>
  );
};
